document.addEventListener('focusout', function() {
	resolveBug()
})

var siteRevealObserver = null;

function initSiteReveals() {
	if (!('IntersectionObserver' in window)) {
		document.querySelectorAll('.site-reveal').forEach(function(el) {
			el.classList.add('is-inview');
		});
		return;
	}

	if (!siteRevealObserver) {
		siteRevealObserver = new IntersectionObserver(function(entries) {
			entries.forEach(function(entry) {
				if (entry.isIntersecting) {
					entry.target.classList.add('is-inview');
					siteRevealObserver.unobserve(entry.target);
				}
			});
		}, {
			rootMargin: '0px 0px -12% 0px',
			threshold: 0.08
		});
	}

	var selectors = [
		'.home-hero'
	].join(',');

	document.querySelectorAll(selectors).forEach(function(el, index) {
		if (el.classList.contains('site-reveal')) return;
		el.classList.add('site-reveal');
		el.style.setProperty('--site-reveal-delay', Math.min(index % 6, 5) * 45 + 'ms');
		siteRevealObserver.observe(el);
	});
}

window.__refreshSiteReveals = initSiteReveals;

document.addEventListener('DOMContentLoaded', function() {
	initSiteReveals();
	var timer = null;
	var observer = new MutationObserver(function() {
		clearTimeout(timer);
		timer = setTimeout(initSiteReveals, 80);
	});
	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
});

function resolveBug(e) {
	setTimeout(function() {
		// alert(1);
		if (document.activeElement.tagName == 'INPUT' || document.activeElement.tagName == 'TEXTAREA') {
			return
		}
		let result = 'pc';
		if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
			result = 'ios'
		} else if (/(Android)/i.test(navigator.userAgent)) { //判断Android
			result = 'android'
		}
		if (result = 'ios') {
			document.activeElement.scrollIntoViewIfNeeded(true);
		}
	}, 10)
}


// window.addEventListener('DOMContentLoaded', function() {
// 	var shuping = 'onorientationchange' in window ? 'orientationchange' : 'resize';
// 	var isAndorid = /(Android)/i.test(navigator.userAgent);
// 	var timer = null;

// 	//设置字体
// 	function setFontSize() {
// 		var w = document.body.clientWidth;
// 		if(w<=750){
// 			//设计图 宽度是750  --------------------> 对应/750, 1rem = 100px;(css已设置)
// 			document.documentElement.style.fontSize = 100 * w / 750 + 'px';
// 		}else{
// 			var w=750;
// 			document.documentElement.style.fontSize = 100 * w / 750 + 'px';
// 		}
// 	}
// 	setFontSize();

// 	//手机横竖屏时 改变大小，Andorid手机切换有延迟 故开定时器
// 	window.addEventListener(shuping, function() {
// 		clearTimeout(timer);
// 		timer = setTimeout(setFontSize, isAndorid ? 300 : 0);
// 	}, false);
// }, false);

//
// var map = new BMap.Map("map");
// var point = new BMap.Point(116.289594, 40.054679);
// map.centerAndZoom(point, 18);
// var marker = new BMap.Marker(point);        // 创建标注
// map.addOverlay(marker);
// map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
//
//
//
//
// function addMarker(point, index) {  // 创建图标对象
// 	var myIcon = new BMap.Icon("markers.png", new BMap.Size(23, 25), {
// 		// 指定定位位置。
// 		// 当标注显示在地图上时，其所指向的地理位置距离图标左上
// 		// 角各偏移10像素和25像素。您可以看到在本例中该位置即是
// 		// 图标中央下端的尖角位置。
// 		anchor: new BMap.Size(10, 25),
// 		// 设置图片偏移。
// 		// 当您需要从一幅较大的图片中截取某部分作为标注图标时，您
// 		// 需要指定大图的偏移位置，此做法与css sprites技术类似。
// 		imageOffset: new BMap.Size(0, 0 - index * 25)   // 设置图片偏移
// 	});
// 	// 创建标注对象并添加到地图
// 	var marker = new BMap.Marker(point, { icon: myIcon });
// 	map.addOverlay(marker);
// }
//
//
// //centre:椭圆中心点,X:横向经度,Y:纵向纬度
// function add_oval(centre, x, y) {
// 	var assemble = new Array();
// 	var angle;
// 	var dot;
// 	var tangent = x / y;
// 	for (i = 0; i < 50; i++) {
// 		angle = (2 * Math.PI / 50) * i;
// 		dot = new BMap.Point(centre.lng + Math.sin(angle) * y * tangent, centre.lat + Math.cos(angle) * y);
// 		assemble.push(dot);
// 	}
// 	return assemble;
// }
// var oval = new BMap.Polygon(add_oval(point, 0.0022, 0.0016), { strokeColor: "#c3c3c5", strokeWeight: 3, strokeOpacity: 0.5 });
// map.addOverlay(oval);



// WEBPACK FOOTER //
// ./src/assets/js/common.js